import { CssUtil } from "../../utils/css-util";
import { StyleManagerBase } from "./style-manager-base";

export class PopUpStyleManager extends StyleManagerBase {

    private readonly siteDesignStyles: HTMLStyleElement;

    public constructor(private readonly styles: HTMLStyleElement) {
        super(styles.ownerDocument);

        this.siteDesignStyles = this.doc.querySelector("#pb-site-design-styles") as HTMLStyleElement ?? StyleManagerBase.ensureSiteDesignStyles(this.doc);
    }

    public static create(doc: Document): PopUpStyleManager {
        const styles = this.createStyles(doc, "pb-popup-generated-styles");
        return new PopUpStyleManager(styles);
    }

    private static createStyles(doc: Document, tagId: string): HTMLStyleElement {
        let styles = doc.getElementById(tagId) as HTMLStyleElement;
        if (!styles) {
            styles = doc.createElement("style");
            styles.id = tagId;
            doc.head.appendChild(styles);
        }

        return styles;
    }

    public override flush(): void {
        CssUtil.flushSheet(this.siteDesignStyles);

        super.flush();
    }

    public get CommonStyle(): HTMLStyleElement {
        return this.siteDesignStyles;
    }

}
